import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { connectSectionFromSide } from "../utils/sectionsHelpers";
import { ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT } from "../constants/connectorKeys";
import UprightComponent from "../components/UprightComponent";
export default class MergeSectionSystem extends SystemBase {
    constructor(_core) {
        super(ComponentIds.ALIGNMENT_CONNECTIONS_COMPONENT_ID);
        this._core = _core;
        this.doingChangesOnComponent = [];
        this.id = "MergeSectionSystem";
        this.systemsAfterMe = [];
        this.systemsBeforeMe = [];
        this.mandatoryComponents = [COMPONENT_IDS.MOUNTING_RAIL_COMPONENT];
    }
    onAddComponent(_entity, _newComponent) {
        var _a;
        const hasUprightParent = (_a = HierarchyUtils.parent(_entity)) === null || _a === void 0 ? void 0 : _a.hasComponent(UprightComponent.id);
        if (hasUprightParent)
            return;
        const offeringMountingRail = HierarchyUtils.parent(_newComponent.connections[0].offeringEntity);
        const fromLeftHandSide = _newComponent.connections[0].demandingConnector.key ===
            ALIGN_MOUNTING_RAIL_TO_UPRIGHT_RIGHT;
        offeringMountingRail &&
            connectSectionFromSide(this._core)(_entity, offeringMountingRail, fromLeftHandSide);
    }
}
